import React from 'react';
export function WhatYouReceive() {
  return <section className="bg-white" data-id="element-320">
      <img src="https://cdn.magicpatterns.com/uploads/sZVcffd4q1Jt8ArtPcoaJj/c1ca4d63-d931-4196-b203-671adb91d45e.webp" alt="Conocé tu guía para sanar y transformarte" className="w-full h-auto block" data-id="element-321" />
    </section>;
}